import UploadStatusContainer from './container';
import UploadStatus from './UploadStatus';

export { UploadStatus };
export default UploadStatusContainer;
